<div class="container-fluid mt-5">
    <div class="content-container">
      <h2>Cài đặt Lưu thông</h2>
      <!-- Nút kích hoạt modal -->
      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal">
        Chỉnh sửa
      </button>

      <!-- Modal -->
      <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Chỉnh sửa</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Đóng"></button>
            </div>
            <div class="modal-body">
              <!-- Nội dung modal -->
              <form>
                <div class="form-group mb-3">
                  <label for="finePerDay">Phí phạt mỗi ngày</label>
                  <input type="number" id="finePerDay" class="form-control" />
                </div>

                <div class="form-group mb-3">
                  <label for="maxFine">Phí phạt tối đa</label>
                  <input type="number" id="maxFine" class="form-control" />
                </div>

                <div class="form-group mb-3">
                  <label for="itemType">Loại vật phẩm</label>
                  <input type="text" id="itemType" class="form-control" />
                </div>

                <div class="form-group mb-3">
                  <label for="loanPeriod">Thời gian mượn</label>
                  <input type="number" id="loanPeriod" class="form-control" />
                </div>

                <div class="form-group mb-3">
                  <label for="renewalsAllowed">Số lần gia hạn cho phép</label>
                  <input type="number" id="renewalsAllowed" class="form-control" />
                </div>

                <div class="form-group mb-3">
                  <label for="holdsAllowed">Số lần giữ chỗ cho phép</label>
                  <input type="number" id="holdsAllowed" class="form-control" />
                </div>

                <button type="submit" class="btn btn-primary">Gửi</button>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Đóng</button>
              <button type="button" class="btn btn-primary">Lưu thay đổi</button>
            </div>
          </div>
        </div>
      </div>

      <div class="item-settings mt-4">
        <p><strong>Phí phạt mỗi ngày:</strong> $0.25</p>
        <p><strong>Phí phạt tối đa:</strong> $10.00</p>
        <p><strong>Loại vật phẩm:</strong> Sách</p>
        <p><strong>Thời gian mượn:</strong> 21 ngày</p>
        <p><strong>Số lần gia hạn cho phép:</strong> 2</p>
        <p><strong>Số lần giữ chỗ cho phép:</strong> Có</p>
      </div>
    </div>
  </div>

